export default "__VITE_ASSET__cKHJd4o6__"